import { rootApi } from '../rootApi';

/**
 * LMS Rapor Eğitmenleri — `/v1/LmsTrainingReportInstructor`.
 * Bkz. docs/LMS-Egitim-Raporlari-API.md §6.
 *
 * Aynı kullanıcı aynı rapora ikinci kez eklenmeye çalışılırsa backend 409 döner (doc §6.2).
 */
export const lmsTrainingReportInstructorApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getLmsTrainingReportInstructors: builder.query({
            query: ({ trainingReportId, userId, userFullName, isActive, pageNumber, pageSize }) => ({
                url: 'v1/LmsTrainingReportInstructor/GetList',
                method: 'POST',
                body: {
                    trainingReportId: trainingReportId ?? null,
                    userId: userId ?? null,
                    userFullName: userFullName || null,
                    isActive: isActive !== undefined ? isActive : null,
                    pageNumber: pageNumber || 1,
                    pageSize: pageSize || 10
                }
            }),
            transformResponse: (response) => {
                if (response && response.data && Array.isArray(response.data.items)) {
                    return { items: response.data.items, totalCount: response.data.totalCount || 0 };
                }
                return { items: [], totalCount: 0 };
            },
            providesTags: ['LmsTrainingReportInstructor']
        }),

        getLmsTrainingReportInstructorById: builder.query({
            query: (id) => ({
                url: 'v1/LmsTrainingReportInstructor/GetById',
                method: 'GET',
                params: { id }
            }),
            transformResponse: (response) => response?.data || null,
            providesTags: ['LmsTrainingReportInstructor']
        }),

        addLmsTrainingReportInstructor: builder.mutation({
            query: ({ trainingReportId, userId }) => ({
                url: 'v1/LmsTrainingReportInstructor/Add',
                method: 'POST',
                body: { trainingReportId, userId }
            }),
            invalidatesTags: ['LmsTrainingReportInstructor']
        }),

        updateLmsTrainingReportInstructor: builder.mutation({
            query: (data) => ({
                url: 'v1/LmsTrainingReportInstructor/Update',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['LmsTrainingReportInstructor']
        }),

        deleteLmsTrainingReportInstructor: builder.mutation({
            query: (id) => ({
                url: `v1/LmsTrainingReportInstructor/${id}`,
                method: 'DELETE'
            }),
            invalidatesTags: ['LmsTrainingReportInstructor']
        })
    }),
    overrideExisting: false
});

export const {
    useGetLmsTrainingReportInstructorsQuery,
    useGetLmsTrainingReportInstructorByIdQuery,
    useAddLmsTrainingReportInstructorMutation,
    useUpdateLmsTrainingReportInstructorMutation,
    useDeleteLmsTrainingReportInstructorMutation
} = lmsTrainingReportInstructorApi;
